import {ApolloDataTable} from "../../atom/Apollo_DataTable";
import {MUISortOptions, SelectableRows} from "mui-datatables";
import React from "react";
import moment from "moment";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import ApolloAccountList from "./Apollo_AccountList";
import {
    apollo_useStyles,
    valueToOption,
    options_state, options_state_edit,
} from "../../atom/Apollo_styles";
import {APOLLO_PROFILE_SYSTEM_ADMIN, APOLLO_SYSTEM_ADMIN, IsAuthorization} from "../../atom/Apollo_Authorization";
import {accountgroupdetail_path} from "../../atom/Apollo_links";
import {STORAGE_KEY} from "../../atom/Apollo_DataTable";
import {
    APOLLO_PAGE_ID,
    getApolloPageSizeSetting,
    saveApolloPageSizeSetting,
} from "../../common/Apollo_LocalStorageSettings";
import {useHistory} from "react-router-dom";
import {ApolloContext} from "../../atom/Apollo_Context";
import Card from "@material-ui/core/Card/Card";
import {AccountGroupColumns, CsvData} from "../../common/Apollo_CommonConst";
import {AccountGroup} from "./AccountModel";
import {valueToLabel} from "../../common/Apollo_CommonUtil";

interface AccountGroupTableProps {
    children?: React.ReactNode;
    rows: any;
}

const ApolloAccountGroupList = (props: AccountGroupTableProps) => {

    const history = useHistory();
    const classes = apollo_useStyles();
    const {state, dispatch} = React.useContext(ApolloContext);
    const isAuthorization = IsAuthorization(APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN);
    const [numberOfRows, setNumberOfRows] = React.useState(
        getApolloPageSizeSetting(APOLLO_PAGE_ID.ACCOUNT_GROUP_LIST)
    );

    const {children, rows, ...other} = props;

    const handleClickAccountgroupOpen = (accountgroupId: number, accountgroupName: string) => {
        var roleAuthorization = 0
        var customSegment = 1
        var geoSegment = 1
        state.apolloList.find((v) => {
            if (v.accountGroup.id === accountgroupId) {
                roleAuthorization = v.accountGroup.roleAuthorization;
                customSegment = v.accountGroup.customSegment;
                geoSegment = v.accountGroup.geoSegment;
            }
        })
        dispatch({
            type: "changeAccount",
            payload: {
                ...state,
                current: {
                    ...state.current,
                    accountGroupId: accountgroupId,
                    accountGroupName: accountgroupName,
                    accountId: 0,
                    accountName: "―",
                    roleAuthorization: roleAuthorization,
                    customSegment: customSegment,
                    geoSegment: geoSegment,
                }
            }
        });
        //画面遷移
        history.push(accountgroupdetail_path + accountgroupId + "?type=li")
    }

    const columns = [
        {
            name: "accountgroupId",
            label: "アカウントグループID",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "accountgroupName",
            label: "アカウントグループ名",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "status",
            label: "ステータス",
            options: {
                filter: true,
                sort: true,
                display: isAuthorization,
                customBodyRender: (value: number) => {
                    return value ? valueToOption(value, options_state).label : ""
                }
            }
        },
        {
            name: "createdAt",
            label: "作成日",
            options: {
                filter: true,
                sort: true,
                display: isAuthorization,
                customBodyRender: (value: number) => {
                    return moment(value).format("YYYY-MM-DD");
                }
            }
        },
        {
            name: "createdBy",
            label: "作成者",
            options: {
                filter: true,
                sort: true,
                display: isAuthorization,
            }
        },
        {
            name: "",
            label: "詳細",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (idx: number) => {
                    return (
                        <KeyboardArrowRightIcon
                            onClick={() => handleClickAccountgroupOpen(rows[idx].accountgroupId, rows[idx].accountgroupName)}
                            className={classes.link}
                            style={{cursor: "pointer"}}
                        />
                    );
                }
            },
        },
    ];

    const sortOrder: MUISortOptions = {
        name: "accountgroupId",
        direction: 'asc',
    }

    const selectableRows: SelectableRows = 'none';

    const options = {
        filter: true,
        downloadOptions: {
            filename: `accountGroups.csv`,
            separator: ",",
            filterOptions: {
                useDisplayedColumnsOnly: false,
                useDisplayedRowsOnly: true,
            }
        },
        onDownload: (buildHead: any, buildBody: any, columns: any, data: any) => {
            const csvData = formatCsvData(data, rows);
            return "\uFEFF" + buildHead(AccountGroupColumns) + buildBody(csvData);
        },
        print: false,
        sort: true,
        sortOrder: localStorage.getItem(STORAGE_KEY.APOLLO_ACCOUNT_GROUP_LIST) ? undefined : sortOrder,
        selectableRows: selectableRows,
        rowsPerPage: numberOfRows,
        rowsPerPageOptions: [10, 25, 50],
        jumpToPage: true,
        expandableRows: true,
        expandableRowsHeader: false,
        expandableRowsOnClick: true,
        storageKey: STORAGE_KEY.APOLLO_ACCOUNT_GROUP_LIST,
        onChangeRowsPerPage: (numberOfRows: number) => {
            saveApolloPageSizeSetting(APOLLO_PAGE_ID.ACCOUNT_GROUP_LIST, numberOfRows);
            setNumberOfRows(numberOfRows);
        },
        renderExpandableRow: (rowData: any, rowMeta: { rowIndex: number, dataIndex: number }) => {
            const colspan = rowData.length + 1;
            return (
                <TableRow>
                    <TableCell colSpan={colspan}>
                        <ApolloAccountList row={rows[rowMeta.dataIndex]} seni="li"/>
                    </TableCell>
                </TableRow>
            );
        },
    }

    return (
        <Card className={classes.root} square variant="outlined">
            <ApolloDataTable
                title=""
                data={rows}
                columns={columns}
                options={
                    {
                        ...options,
                        textLabels:{
                            body: {noMatch: "該当データが存在しません"}
                        },
                    }
                }
            />
        </Card>
    );
}

const formatCsvData = (data: any[], tableData: AccountGroup[]): CsvData[] => {
    const dataList: CsvData[] = [];
    data?.map((v: { index: any, data: any[] }) => {
          if (!v.data || v.data.length === 0) return;
          const values = tableData.filter((td) => td.accountgroupId === v.data[0]);
          if (!values || values.length === 0) return;
          const d = values[0];
          const list: CsvData = {
              index: v.index,
              data: [
                  d.accountgroupId,
                  d.accountgroupName,
                  valueToLabel(d.status, options_state_edit),
                  moment(d.createdAt).format("YYYY-MM-DD"),
                  d.createdBy,
              ],
          };
          dataList.push(list);
      }
    );
    return dataList;
}

export default ApolloAccountGroupList;
